// extracted by mini-css-extract-plugin
module.exports = {"base":"ComponentLink_base__gZZQX"};